/* @flow */

export default {

  FILTER_SEARCH_RADIUS: 'searchRadius',

  FILTER_ACTIVITY_TYPE: 'activityType',

  FILTER_PRODUCT_GROUP: 'productGroup'

};
